import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-521e2e64"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "News", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Read the latest about Derivitec.", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "third" }, "News", -1))
const _hoisted_4 = { class: "two-thirds" }
const _hoisted_5 = { class: "article" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { style: {"white-space":"pre-wrap"} }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_panel = _resolveComponent("panel")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_panel, {
      class: "head",
      bg: true
    }, {
      default: _withCtx(() => [
        _hoisted_1,
        _hoisted_2
      ]),
      _: 1
    }),
    _createVNode(_component_panel, { class: "columns py-20" }, {
      default: _withCtx(() => [
        _hoisted_3,
        _createElementVNode("ul", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.news, (item) => {
            return (_openBlock(), _createElementBlock("li", {
              key: item.id
            }, [
              _createVNode(_component_router_link, {
                to: { name: 'NewsItem', params: { id: item.id } }
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_5, [
                    (item.subTitle)
                      ? (_openBlock(), _createElementBlock("h6", _hoisted_6, _toDisplayString(item.subTitle), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("h2", _hoisted_7, _toDisplayString(item.title), 1),
                    (item.date)
                      ? (_openBlock(), _createElementBlock("h5", _hoisted_8, _toDisplayString(_ctx.toDate(item.date)), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("p", {
                      innerHTML: item.description
                    }, null, 8, _hoisted_9)
                  ])
                ]),
                _: 2
              }, 1032, ["to"])
            ]))
          }), 128))
        ])
      ]),
      _: 1
    })
  ]))
}